// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-button {
  right: 10px; 
  top: 80%;
  transform: translateY(-50%); 
  border: .10px solid #ccc;
  border-radius: 20%;
  padding: 2px 4px;
  text-decoration: none;
  background: none;
  color: #2e2e2e;
  
}

.copy-button:hover {
  background-color:#2e2e2e;
  border: .10px solid #ccc;
}
  

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}


.custom-checkbox input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: white;
  border: 2px solid #F37920;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  display: inline-block;
  position: relative;
}

.custom-checkbox input[type="checkbox"]:checked {
  background-color:  #F37920;
  border: 2px solid #F37920;
}

.custom-checkbox input[type="checkbox"]::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 4px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  display: none;
}

.custom-checkbox input[type="checkbox"]:checked::after {
  display: block;
}


.alert-overlay-absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/forms/hsnSac/hsnSac.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EAKE,cAAc;AAHhB;;;AAOA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".copy-button {\n  right: 10px; \n  top: 80%;\n  transform: translateY(-50%); \n  border: .10px solid #ccc;\n  border-radius: 20%;\n  padding: 2px 4px;\n  text-decoration: none;\n  background: none;\n  color: #2e2e2e;\n  \n}\n\n.copy-button:hover {\n  background-color:#2e2e2e;\n  border: .10px solid #ccc;\n}\n  \n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n\n.custom-checkbox input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  border: 2px solid #F37920;\n  border-radius: 3px;\n  cursor: pointer;\n  outline: none;\n  display: inline-block;\n  position: relative;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked {\n  background-color:  #F37920;\n  border: 2px solid #F37920;\n}\n\n.custom-checkbox input[type=\"checkbox\"]::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 4px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  display: none;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked::after {\n  display: block;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked::after {\n  display: block;\n}\n\n\n.alert-overlay-absolute {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
